import gql from 'graphql-tag';

export default gql`
  mutation removeByIdPostMutation($_id: MongoID!) {
    removeByIdPostMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
